import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { UserStatus } from '../../store/auth/authSlice';
import { ProfileRole, ProfileStatusEnum } from '../../store/profile/profileSlice';

export const useAuthRedirect = () => {
    const { user } = useSelector((state) => state.auth);
    const { currentProfile } = useSelector((state) => state.profile);
    const { pathname } = useLocation();
    const publicRoutes = ['/login', '/register', '/forgot'];

    if (!user && !publicRoutes.includes(pathname) && !pathname.includes('/password-reset')) {
        return '/login';
    }

    if (user && user.status === UserStatus.PENDING && pathname !== '/verify') {
        return '/verify';
    }

    if (user && user.status === UserStatus.ACTIVE && currentProfile?.role === ProfileRole.GUEST && pathname !== '/create/profile') {
        return '/create/profile';
    }

    if(currentProfile && currentProfile?.status === ProfileStatusEnum.active && ([ProfileRole.TUTOR, ProfileRole.STUDENT].includes(currentProfile?.role)) && pathname === '/create/profile') {
        return '/';
    }
    
    
    // Post-approval /laststep onboarding disabled — availability & pricing are collected in the tutor wizard
    // if(user && user.status === UserStatus.ACTIVE && (currentProfile?.role === ProfileRole.STUDENT || (currentProfile?.role === ProfileRole.TUTOR && currentProfile?.lastStep === true && currentProfile?.status === ProfileStatusEnum.active)) && pathname === '/laststep') {
    //     return '/';
    // }
    
    // if (user &&  currentProfile?.status === ProfileStatusEnum.active && user.status === UserStatus.ACTIVE && ProfileRole.TUTOR === currentProfile?.role && currentProfile?.lastStep === false && !['/laststep'].includes(pathname)) {
    //     return '/laststep';
    // }
    
    if (user && user.status === UserStatus.ACTIVE && currentProfile?.status === ProfileStatusEnum.active && [ProfileRole.TUTOR, ProfileRole.STUDENT].includes(currentProfile?.role) && ['/login', '/register', 'verify', '/forgot', '/password-reset', "/create/profile"].includes(pathname)) {
        console.log("user and currentProfile", user, currentProfile)
        return '/';
    }

    return null;
};